import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class OeQuoteListItem extends SearchModelBase {
    id: number = 0;
    quoteNo: string = '';
    quoteDate: string | null = null;
    fromQuoteDate: string | null = null;
    toQuoteDate: string | null = null;
    operator: string = '';
    serviceType: string = '';
    hblNo: string = '';
    hBookingNo: string = '';
    sName: string = '';
    commodity: string = '';
    plofRec: string = '';
    lPort: string = '';
    discharge: string = '';
    finalDest: string = '';
    plofDel: string = '';
    createdAt: string | null = null;
    agentId: number = 0;
    customerId: number = 0;
    u1ID: string = '';
    u2ID: string = '';
    u2Date: string | null = null;
    status: string = '';
    mblRefNo: string = '';
    validBy: string | null = null;
    fromValidBy: string | null = null;
    toValidBy: string | null = null;
    sManID: string = '';
    contactName: string = '';
    fromCreatedAt: string | null = null;
    toCreatedAt: string | null = null;
    fromU2Date: string | null = null;
    toU2Date: string | null = null;
    opType: string = '';

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: '', width: 30, dataIndex: 'status', hiddenInColumnSetup: true, sortable: false}),
        XCol.Create({ col: 1, text: 'Date', width: 75, dataIndex: 'quoteDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 2, text: 'Quotation #', width: 100, dataIndex: 'quoteNo', defaultColumnFocus : true}),
        XCol.Create({ col: 3, text: 'Quote By', width: 80, dataIndex: 'operator'}),
        XCol.Create({ col: 4, text: 'Valid By', width: 75, dataIndex: 'validBy', type: XCol.XCellType.Date}),
        XCol.Create({ col: 5, text: 'Customer', width: 120, dataIndex: 'sName'}),
        XCol.Create({ col: 6, text: 'Contact', width: 120, dataIndex: 'contactName'}),
        XCol.Create({ col: 7, text: 'Booking #', width: 120, dataIndex: 'hBookingNo'}),
        // XCol.Create({ col: 8, text: 'Ref. No(MBL)', width: 100, dataIndex: 'mblRefNo'}),
        XCol.Create({ col: 9, text: 'Move Type', width: 80, dataIndex: 'serviceType', noNullOrEmptySearch: true}),
        XCol.Create({ col: 10, text: 'Commodity', width: 150, dataIndex: 'commodity'}),
        XCol.Create({ col: 11, text: 'Place of Receipt', width: 120, dataIndex: 'plofRec', visible: false}),
        XCol.Create({ col: 12, text: 'Loading Port', width: 120, dataIndex: 'lPort'}),
        XCol.Create({ col: 13, text: 'Discharge Port', width: 120, dataIndex: 'discharge'}),
        XCol.Create({ col: 14, text: 'Place of Delivery', width: 120, dataIndex: 'plofDel'}),
        XCol.Create({ col: 15, text: 'Final Destination', width: 120, dataIndex: 'finalDest'}),
        XCol.Create({ col: 16, text: 'Salesperson', width: 80, dataIndex: 'sManID'}),
        XCol.Create({ col: 17, text: 'Create Date', width: 100, dataIndex: 'createdAt', type: XCol.XCellType.DateTime}),
        XCol.Create({ col: 18, text: 'Create by', width: 80, dataIndex: 'u1ID'}),
        XCol.Create({ col: 19, text: 'Update Date', width: 100, dataIndex: 'u2Date', type: XCol.XCellType.DateTime}),
        XCol.Create({ col: 20, text: 'Update by', width: 80, dataIndex: 'u2ID'}),
        ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: OeQuoteListItem.prototype.createdAt, orderByAscending: false };

    public static formatData(data: OeQuoteListItem[]) {
        return data.map((d: OeQuoteListItem) => ({
          ...d,
        }));
    }

    public static MapOeSearchFields: {[key: string]: {[key: string]: string}} = {
        quoteDate: {from: 'fromQuoteDate', to: 'toQuoteDate'},
        validBy: {from: 'fromValidBy', to: 'toValidBy'},
        createdAt: {from: 'fromCreatedAt', to: 'toCreatedAt'},
        u2Date: {from: 'fromU2Date', to: 'toU2Date'},
    }
}
